export default __webpack_public_path__ + "static/media/customLogo.50a90e08.png";